var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<span class="default-text">'+
((__t=( data.text ))==null?'':_.escape(__t))+
'</span>\n<span class="loading-text">'+
((__t=( data.loading_text || data.text ))==null?'':_.escape(__t))+
'</span>\n';
return __p;
};
